import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { OperationTypeMoveTypeEnum } from '@zaoblako/shared/modules/document/enums/operation.type.move.type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link OperationTypeMoveTypeEnum} enumeratino values */
export const OperationTypeMoveTypeEnumI18n: EnumI18nInterface<OperationTypeMoveTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [OperationTypeMoveTypeEnum.DECREMENT]: 'Уменьшать',
    [OperationTypeMoveTypeEnum.EXCLUDE]: 'Не учитывать',
    [OperationTypeMoveTypeEnum.INCREMENT]: 'Увеличивать',
  },
  [I18nLocalesEnum.EN_US]: {
    [OperationTypeMoveTypeEnum.DECREMENT]: 'Decrement',
    [OperationTypeMoveTypeEnum.EXCLUDE]: 'Exclude',
    [OperationTypeMoveTypeEnum.INCREMENT]: 'Increment',
  }
};
